import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import { DataTypeProvider, } from '@devexpress/dx-react-grid'

export default class StringTypeProvider extends Component {
  render() {
    return(
      <DataTypeProvider
        for={this.props.for}
        editorComponent={({ column, row, value, onValueChange }) =>
          (this.props.editable || !row) && this.props.searchable ?
          <TextField
            style={{ margin: 8 }}
            fullWidth
            value={value || ''}
            placeholder={!row ? "Filter..." : ""}
            onChange={event => onValueChange(event.target.value)} /> :
          <div/>
        }
      />
    );
  }
}

StringTypeProvider.defaultProps = {
  editable: true,
  searchable: true,
};

StringTypeProvider.propTypes = {
  for: PropTypes.array.isRequired,
  editable: PropTypes.bool,
  searchable: PropTypes.bool,
}
